

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const Ben_ver_list = () => {
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);
    const [selected, setSelected] = useState([]);
    const [userRole, setUserRole] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadList();
    }, []);

    const loadList = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL}/api/ben/ben_ver_list`, {
                withCredentials: true
            });
            setList(res.data.list || []);
            setTotal(res.data.total || 0);
            setUserRole(res.data.userRole || '');
            console.log('User Role from backend:', res.data.userRole);
        } catch (error) {
            console.error('Error loading list:', error);
            if (error.response?.data?.message === "Session Expired") {
                alert("Session Expired");
            }
        } finally {
            setLoading(false);
        }
    };

    const toggleCheckbox = (slno) => {
        if (selected.includes(slno)) {
            setSelected(selected.filter(s => s !== slno));
        } else {
            setSelected([...selected, slno]);
        }
    };

    const memberApprove = async () => {
        if (selected.length === 0) {
            alert('Please Select atleast one Person');
            return;
        }
        setLoading(true);
        const formData = new FormData();
        selected.forEach(s => formData.append('slno', s));
        try {
            await axios.post(`${process.env.REACT_APP_URL}/api/ben/ben_ver_afso_seed_Update`, formData, {
                withCredentials: true
            });
            alert('Approved Successfully');
            await loadList();
            setSelected([]);
        } catch (error) {
            console.error('Error in approval:', error);
            if (error.response?.data?.message === "Session Expired") {
                alert("Session Expired");
            } else {
                alert('Error in approval');
            }
        } finally {
            setLoading(false);
        }
    };

    const memberReject = async () => {
        if (selected.length === 0) {
            alert('Please Select atleast one Person');
            return;
        }
        setLoading(true);
        const formData = new FormData();
        selected.forEach(s => formData.append('slno', s));
        try {
            await axios.post(`${process.env.REACT_APP_URL}/api/ben/ben_ver_afso_seed_reject`, formData, {
                withCredentials: true
            });
            alert('Rejected Successfully');
            await loadList();
            setSelected([]);
        } catch (error) {
            console.error('Error in rejection:', error);
            if (error.response?.data?.message === "Session Expired") {
                alert("Session Expired");
            } else {
                alert('Error in rejection');
            }
        } finally {
            setLoading(false);
        }
    };

    const hasPermission = userRole === "1" || userRole === "2" || userRole === "3";
    const hasData = list.length > 0; 

    return (
        <div id="wrapper">
            <div className="wrapper row3">
                <div id="container">
                    <div align="center">
                        {hasData && (
                            <>
                                <div align="center">
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                        Total Pending Verifications : 
                                    </span>
                                    <span style={{ color: 'red', fontWeight: 'bold' }}> {total}</span>
                                </div>

                                {total > 500 && (
                                    <div align="center" style={{ color: 'red', fontWeight: 'bold', margin: '10px 0' }}>
                                        Note : The screen shows only 500 verifications after approval/rejection, next 500 will be displayed
                                    </div>
                                )}

                                <br />
                                <div className="mainhead" style={{ textAlign: 'center' }}>
                                    Beneficiary Verification List
                                </div>
                                <br /><br />

                                {hasPermission && (
                                    <div align="center" style={{ margin: '15px 0' }}>
                                        <button onClick={memberApprove} className="button button2" style={{ marginRight: "10px" }} disabled={loading}>
                                            Member Approve
                                        </button>
                                        <button onClick={memberReject} className="button button2" disabled={loading}>
                                            Member Reject
                                        </button>
                                    </div>
                                )}

                                <br />
                            </>
                        )}

                        {loading ? (
                            <div align="center" style={{ marginTop: "50px" }}>
                                <CircularProgress />
                            </div>
                        ) : hasData ? (
                            <>
                                <table width="100%" align="center" border="1" cellPadding="5">
                                    <thead>
                                        <tr className="tableheader">
                                            <th rowSpan="2">Sl.No</th>
                                            <th colSpan="6" style={{ color: '#66ff99' }}><u>RC Details</u></th>
                                            <th rowSpan="2" style={{ background: '#000033' }}></th>
                                            <th colSpan="6" style={{ color: '#00ffff' }}><u>Verification Details</u></th>
                                            <th rowSpan="2">Matching<br />%</th>
                                            <th rowSpan="2">Approve</th>
                                        </tr>
                                        <tr className="tableheader">
                                            <th>FPS Id</th>
                                            <th>FPS Name</th>
                                            <th>Card No</th>
                                            <th>UID</th>
                                            <th>Name</th>
                                            <th>Gender</th>
                                            <th>Name</th>
                                            <th>UID</th>
                                            <th>DOB</th>
                                            <th>Gender</th>
                                            <th>District</th>
                                            <th>PIN Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map((item, idx) => (
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{item.fps_id}</td>
                                                <td>{item.fps_name_en}</td>
                                                <td>{item.existing_rc_number}</td>
                                                <td>{item.rc_uid}</td>
                                                <td>{item.rc_member_name}</td>
                                                <td>{item.rc_gender}</td>
                                                <td style={{ background: '#000033' }}></td>
                                                <td>{item.poi_name}</td>
                                                <td>{item.uid}</td>
                                                <td>{item.poi_dob}</td>
                                                <td>{item.poi_gender}</td>
                                                <td>{item.poa_dist}</td>
                                                <td>{item.poa_pc}</td>
                                                <td align="right">{item.matching}</td>
                                                <td align="center">
                                                    {hasPermission ? (
                                                        <input 
                                                            type="checkbox" 
                                                            checked={selected.includes(item.slno)} 
                                                            onChange={() => toggleCheckbox(item.slno)} 
                                                            disabled={loading}
                                                        />
                                                    ) : '-NA-'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>
                        ) : (
                            <div align="center">
                                <br/><br/><br/><br/>
                                <div className="response">Details Not Found</div>
                                <br/><br/><br/><br/>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ben_ver_list;